import Site from 'stores/Site'
import Header from 'components/Header'
import MobileNav from 'components/MobileNav'

import Home from 'pages/Home'
import Solutions from 'pages/Solutions'
import Software from 'pages/Software'
import Industry from 'pages/Industry'
import About from 'pages/About'
import Wall from 'pages/Wall'
import Campaign from 'pages/Campaign'
import Event from 'pages/Event'
import Default from 'pages/Default'

class App {
    constructor() {
        this.checkMobile()
        Site.windowWidth = window.innerWidth
        Site.platformOnLoad = Site.isMobile ? 'mobile' : 'desktop'

        this.classes = []
        this.pageClasses = {
            default: Default,
            home: Home,
            solutions: Solutions,
            software: Software,
            industry: Industry,
            about: About,
            wall: Wall,
            campaign: Campaign,
            event: Event,
        }

        document.addEventListener('DOMContentLoaded', ()=> {
            Site.html = document.documentElement
            Site.body = document.querySelector('body')
            Site.page = document.querySelector('.main')

            this.init()
        })
    }

    init() {
        this.initAnchors()
        this.addEvents()
        this.initHeader()
        this.initMobileNav()
        this.initPage()
    }

    initAnchors() {
        if (Site.page.getAttribute('id') !== 'software-single') return

        history.scrollRestoration = 'manual'
        window.scrollTo(0, 0)

        const hash = window.location.hash
        if (!hash) return

        const target = document.querySelector(hash)
        if (!target) return

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const top = target.getBoundingClientRect().top + window.scrollY - Site.header.offsetHeight
                window.scrollTo({ top, behavior: 'smooth' })
            })
        })
    }

    checkMobile() {
        Site.isMobile = window.innerWidth <= 1100
        Site.platform = Site.isMobile ? 'mobile' : 'desktop'
    }

    addEvents() {
        this.onScroll = this.onScroll.bind(this)
        this.onResize = this.onResize.bind(this)

        window.addEventListener('scroll', this.onScroll)
        window.addEventListener('resize', this.onResize)
    }

    initPage() {
        const id = Site.page.getAttribute('id')

        const pageClass = this.pageClasses.hasOwnProperty(id) ? new this.pageClasses[id] : new this.pageClasses['default']
        pageClass.init()
    }

    initHeader() {
        const el = document.querySelector('.header')

        Site.header = el

        this.classes.push(new Header(el))
    }

    initMobileNav() {
        const el = document.querySelector('.mobile-nav')

        this.classes.push(new MobileNav(el))
    }


    onResize(e) {
        if (window.innerWidth === Site.windowWidth) {
            return
        } else {
            Site.windowWidth = window.innerWidth
        }

        this.checkMobile()

        if (Site.platformOnLoad !== Site.platform) {
            window.location.reload()
        }

        this.classes.forEach(instance => {
            instance.onResize && instance.onResize(e)
        })
    }

    onScroll(e) {
        this.classes.forEach(instance => {
            instance.onScroll && instance.onScroll(e)
        })
    }
}

new App()